<template>
  <div>
    <h3>大纲编辑</h3>
    <div>
      <el-form @submit.native.prevent="editTimeline" class="selectnews">
        <el-form-item label="选择网校">
          <el-select v-model="model.maID" placeholder="网校">
            <el-option
              v-for="item in major"
              :key="item.maID"
              :label="item.maName"
              :value="item.maID"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="一级分类">
          <el-select
            multiple
            v-model="model.chID"
            @change="getCourse"
            placeholder="一级分类"
          >
            <el-option
              v-for="item in channel"
              :key="item.chID"
              :label="item.chName"
              :value="item.chID"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级分类">
          <el-select
            multiple
            v-model="model.coID"
            @change="getClass"
            placeholder="二级分类"
          >
            <el-option
              v-for="item in course"
              :key="item.coID"
              :label="item.coName"
              :value="item.coID"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item multiple label="三级分类">
          <el-select v-model="model.clID" multiple placeholder="三级分类">
            <el-option
              v-for="item in shclass"
              :key="item.clID"
              :label="item.clName"
              :value="item.clID"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form> </el-form>
        <el-form-item label="请修改讲师+直播时间">
          <el-input
            v-model="model.timeStamp"
            placeholder="倩倩老师 11月23日19:30-20:30"
          ></el-input>
        </el-form-item>
        <el-form-item label="请修改专业+课程内容">
          <el-input
            v-model="model.timeText"
            placeholder="[护士资格]24教材/大纲变动解读"
          ></el-input>
        </el-form-item>

        <el-form-item label="请输入直播/回放链接">
          <el-input v-model="model.timeUrl" placeholder=""></el-input>
        </el-form-item>

        <el-form-item label="请勿修改timeID">
          <el-input :disabled="true" v-model="model.timeID"></el-input>
        </el-form-item>

        <el-form-item style="float: right; margin-top: 15px">
          <el-button type="primary" native-type="submit">点击修改</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      major: [],
      channel: [],
      course: [],
      shclass: [],
      lineData: [],
      model: {
        maID: "",
        chID: "",
        coID: "",
        clID: "",
        timeStamp: "",
        timeText: "",
        timeUrl: "",
        timeID: "",
      },
      activeName: "first",
    };
  },
  //props: ["clientId"],
  methods: {
    async editTimeline() {
      try {
        const result = await this.$http.put(
          "/timeline/putline?_id=" + `${this.id}`,
          this.model
        );
        if (result.status == 201) {
          this.$message({
            type: "success",
            message: result.data.msg,
          });
          this.$router.push("/timeline/list");
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getMajor() {
      try {
        const getmajor = await this.$http.get("/major/getmajor");
        this.major = getmajor.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getChannel(item) {
      try {
        const getchannel = await this.$http.get("/category/getchannel");
        this.channel = getchannel.data;
        //this.getlesson(item);
      } catch (error) {
        console.log(error);
      }
    },
    async getCourse(item) {
      try {
        const getcourse = await this.$http.get("/category/getcourse", {
          params: { chID: item },
        });
        this.course = getcourse.data;
        //this.getlesson(item);
      } catch (error) {
        console.log(error);
      }
    },
    async getClass(item) {
      try {
        const getclass = await this.$http.get("/category/getclass", {
          params: { coID: item },
        });
        this.shclass = getclass.data;
        //this.getlesson(item);
      } catch (error) {
        console.log(error);
      }
    },
    async getEditTimeLine(id) {
      try {
        const result = await this.$http.get("/timeline/editline", {
          params: {
            id,
          },
        });
        //console.log(result.data[0]);
        this.model.maID = result.data[0].maID;
        this.model.chID = result.data[0].chID;
        this.model.coID = result.data[0].coID;
        this.model.clID = result.data[0].clID;
        this.model.timeStamp = result.data[0].timeStamp;
        this.model.timeText = result.data[0].timeText;
        this.model.timeUrl = result.data[0].timeUrl;
        this.model.timeID = result.data[0].timeID;
      } catch (error) {
        console.log(error);
      }
    },
  },

  created() {
    this.getMajor();
    this.getChannel();
    this.id && this.getEditTimeLine(this.id);
  },
};
</script>

<style></style>
